import { List as IList } from 'immutable';

import { createSelector } from 'reselect';
import { programStepCompleted } from '../program/programStepSelectors';
import { cardTypeStepCompleted } from '../cardType/cardTypeStepSelectors';
import { getFlowProgress } from '../routing/flowSelectors';
import { AMOUNT_FIELD, CURRENCY_FIELD } from '../item/newItemForm';



export const amountStepCompleted = createSelector(
    getFlowProgress,
    flowState => flowState.has(AMOUNT_FIELD) && flowState.has(CURRENCY_FIELD)
);


export const amountStepPreConditions = IList([
    programStepCompleted,
    cardTypeStepCompleted
]);


export const amountStepPostConditions = IList([
    amountStepCompleted
]);
